import type { ModuleFile } from '../../core/modules.ts';

// Módulo «projects»: manifiesto. Las pantallas se cargan de forma perezosa.
export const manifests: ModuleFile['manifests'] = [
  {
    id: 'projects',
    title: 'Proyectos',
    path: 'proyectos',
    nav: { group: 'Trabajo', label: 'Proyectos', icon: '▤', order: 2 },
    projectLayout: () => import('./ProjectLayout.tsx').then((m) => ({ default: m.ProjectLayout })),
    load: () => import('./ProjectsPage.tsx').then((m) => ({ default: m.ProjectsPage })),
  },
  {
    id: 'brief',
    title: 'Encargo',
    projectTab: { segment: 'encargo', label: 'Encargo', order: 1 },
    load: () => import('./BriefPage.tsx').then((m) => ({ default: m.BriefPage })),
  },
];
